import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import { zIndex } from "../../../../zApps/Layout/zIndex";
import { EllipsisLabel } from "../../../EllipsisLabel/EllipsisLabel";
import { OtherUser } from "../../types";

export function NameAndLevel({ targetUser }: { targetUser: OtherUser }) {
    const c = useStyles();
    return (
        <div className={c.titleAndLevelContainer}>
            <h2 className={c.title}>
                <EllipsisLabel
                    title={targetUser.name}
                    placement="top-start"
                    tooltipProps={{
                        PopperProps: {
                            className: c.tooltipPopper,
                        },
                    }}
                    style={{ lineHeight: 2 }}
                />
            </h2>
            <Card className={c.level}>Lv. {targetUser.level}</Card>
        </div>
    );
}
const useStyles = makeStyles({
    titleAndLevelContainer: {
        marginTop: -21,
        height: 76,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    title: {
        margin: 0,
        height: "100%",
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
    },
    level: {
        display: "inline",
        backgroundColor: "#047c28",
        color: "white",
        fontSize: "large",
        padding: "2px 5px",
        marginLeft: 8,
        whiteSpace: "nowrap",
        flexShrink: 0,
        fontWeight: "bold",
    },
    tooltipPopper: { zIndex: zIndex.panelAndDialog.panelOrDialog(0) + 1 },
});
